import React from 'react'
import { useSelector } from 'react-redux'

import { Heading, Stack } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { Page } from '@app/lib/layout/Page/Page'
import { PageContent } from '@app/lib/layout/Page/PageContent'
import { PageHeader } from '@app/lib/layout/Page/PageHeader'
import { AuditReportsWidget } from '@app/modules/AuditReports/AuditReportsWidget'
import { AuthSelectors } from '@app/modules/Auth'
import { NavBar } from '@app/NavBar/NavBar'

export const AuditReportsPage = () => {
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const { formatMessage } = useIntl()
  return (
    <NavBar title='Prüfungsberichte'>
      <Page>
        <PageHeader>
          <Heading size={Heading.sizes.medium}>
            {formatMessage({ id: 'Lawyer.AuditReports.Heading' })}
          </Heading>
        </PageHeader>
        <PageContent>
          <Stack>{lawyerId && <AuditReportsWidget lawyerId={parseInt(lawyerId, 10)} />}</Stack>
        </PageContent>
      </Page>
    </NavBar>
  )
}
